import { FC, useState } from 'react'
import { Modal } from 'react-bootstrap'
import CloseButton from 'react-bootstrap/CloseButton';

const AcceptInviteDialog: FC<{
  showConfirmationDialog: boolean;
  groups: any;
  isFirstStepCompleted?: boolean;
  onCloseDialog?: () => void;
}> = ({ showConfirmationDialog, groups, isFirstStepCompleted, onCloseDialog }) => {
  const [isConfirmed, setIsConfirmed] = useState(isFirstStepCompleted)

  const handleConfirmData = () => {
    setIsConfirmed(true)
  }

  const handleLinkButton = (path: string) => {
    window.location.replace(path)
  }

  const isCompanyAdmin = groups.some((group: any) => group === 'Company Admins')
  const isSupervisorOrHS = groups.some((group: any) =>
    ['Supervisor', 'H&S Specialist'].includes(group)
  )

  return (
    <>
      {showConfirmationDialog && (
        <Modal show={showConfirmationDialog} tabIndex={0} centered>
          <Modal.Body>
            {Boolean(isFirstStepCompleted) && (
              <CloseButton
                onClick={() => onCloseDialog && onCloseDialog()}
                className='btn position-absolute p-1'
                style={{ top: '20px', right: '20px' }} />
            )}
            <div className='py-5 d-flex flex-column gap-6'>
              {isFirstStepCompleted ? (
                <video
                  className='exclamation align-self-center'
                  src='/media/exclamation.mp4'
                  autoPlay
                  loop
                  muted
                  playsInline
                  poster='/media/exclamation.gif'
                />
              ) : (
                <img
                  className='congratulations align-self-center'
                  src='/media/congratulations.gif'
                  alt='Congratulations'
                />
              )}
              <div className='d-flex gap-1 flex-column'>
                <div className='align-self-center congratulation-text'>
                  {isFirstStepCompleted ? 'Access Restricted' : 'Congratulations !'}
                </div>
                <div>
                  <div className='congratulation-sub-text align-self-center text-center'>
                    {isFirstStepCompleted
                      ? 'This portal is available to authorized admin users only.'
                      : 'Your User Created Successfully.'}
                  </div>
                  <div className='congratulation-sub-text align-self-center text-center'>
                    {isFirstStepCompleted &&
                      'Please sign in through the Web App or Mobile App to continue.'}
                  </div>
                </div>
              </div>
              {isConfirmed ? (
                <div className='btn-align'>
                  {isCompanyAdmin && (
                    <button
                      type='submit'
                      className='btn btn-primary btn-pill accept-invite-redirect-btn align-self-center link-btn'
                      onClick={() => handleLinkButton(`${process.env.REACT_APP_URL}`)}
                    >
                      Continue on Admin Panel
                      <img
                        className='ms-3'
                        src='/media/icons/duotune/general/Arrow - Right.svg'
                        alt='->'
                      />
                    </button>
                  )}
                  {isSupervisorOrHS && (
                    <>
                      <button
                        type='submit'
                        className='btn btn-pill accept-invite-redirect-btn mobile-app-link-btn align-self-center link-btn'
                        onClick={() => handleLinkButton(`${process.env.REACT_APP_API_FLUTTER_URL}`)}
                      >
                        Login to Web App
                        <img
                          className='ms-3'
                          src='/media/icons/duotune/general/blue-arrow.svg'
                          alt='->'
                        />
                      </button>
                      <button
                        type='submit'
                        className='btn btn-pill accept-invite-redirect-btn mobile-app-link-btn align-self-center link-btn'
                        onClick={() => handleLinkButton(`${process.env.REACT_APP_MOBILE_URL}`)}
                        style={{ marginTop: '0.3rem' }}
                      >
                        Continue on Mobile App
                        <img
                          className='ms-3'
                          src='/media/icons/duotune/general/blue-arrow.svg'
                          alt='->'
                        />
                      </button>
                    </>
                  )}
                </div>
              ) : (
                <button
                  type='submit'
                  className='btn btn-primary btn-pill dialog-done-btn submit-btn align-self-center'
                  onClick={handleConfirmData}
                >
                  Done
                  <img
                    className='ms-3'
                    src='/media/icons/duotune/general/Arrow - Right.svg'
                    alt='->'
                  />
                </button>
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}

export { AcceptInviteDialog }
